import React, { useEffect, useState } from 'react';
import { ListGroup, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { YardList, PostYard } from '../../API/Inventory';
import { GetOfficeList } from '../../API/Office';
import { DropdownList } from 'react-widgets';
import { faSortAmountUp, faSortAmountDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default props => {
    const [yard, setYard] = useState({
        name: "",
        officeLocationId: -1
    })
    const [offices, setOffices] = useState([])
    const [yards, setYards] = useState([])
    const [errorText, setErrorText] = useState("")


    //Sorting values: 0 = default, 1 = decending, 2 = ascending 
    const [nameSort, setNameSort] = useState(0);
    const [officeSort, setOfficeSort] = useState(0);
    const [classes, setClasses] = useState(["clickable", "clickable"])



    useEffect(() => {
        LoadYardList();
        GetOfficeList()
            .then(res => {
                res.data.unshift(
                    {
                        name: "Select Office",
                        officeLocationId: -1
                    }
                )
                setOffices(res.data)
            })
    }, [])

    const LoadYardList = () => {
        YardList()
            .then(res => {
                setYards(res.data)
            })
    }

    const changeYard = (key, value) => {
        let s = { ...yard };
        s[key] = value;
        setYard(s)
    }

    const saveYard = () => {
        if (yard.officeLocationId === -1){
            setErrorText("Please select an office");
            return;
        }
        PostYard(yard)
            .then(res => {
                LoadYardList();
            })
    }


    const setClass = (headerID) => {
        let newArr = [...classes]

        classes.forEach((c, index) => {
            if (headerID === index) {
                newArr[index] = "clickable fa-icon-toggle-on"
            }
            else {
                newArr[index] = "clickable"
            }
        })

        setClasses(newArr)

    }


    const headerSort = (headerID, direction) => {

        setClass(headerID)


        if (headerID === 0 && direction === 1) {
            setNameSort(2)
            yards.sort((a, b) => a.yardName.localeCompare(b.yardName));
        }
        else if (headerID === 0 && direction === 2) {
            setNameSort(1)
            yards.sort((a, b) => a.yardName.localeCompare(b.yardName));
            yards.reverse();
        }
        //---------------------------------------------------------------------------
        if (headerID === 1 && direction === 1) {
            setOfficeSort(2)
            yards.sort((a, b) => a.officeName.localeCompare(b.officeName));
        }
        else if (headerID === 1 && direction === 2) {
            setOfficeSort(1)
            yards.sort((a, b) => a.officeName.localeCompare(b.officeName));
            yards.reverse();
        }
      

    }

    return (
        <div className="container">
            <div className="row">
                <div className="col">
                    <ListGroup>
                        <ListGroup.Item className="enc-data-list">
                            Yard List
                        </ListGroup.Item>
                        <ListGroup.Item className="enc-data-list">
                            <div className="row">

                                <div className="col">
                                    Yard Name {nameSort === 0 || nameSort === 1 ? < FontAwesomeIcon icon={faSortAmountDown} className = { classes[0]} onClick={() => headerSort(0, 1)} /> : < FontAwesomeIcon icon={faSortAmountUp} className = { classes[0]} onClick={() => headerSort(0, 2)} />}
                                </div>
                                <div className="col">
                                    Office Location {officeSort === 0 || officeSort === 1 ? < FontAwesomeIcon icon={faSortAmountDown} className = { classes[1]} onClick={() => headerSort(1, 1)} /> : < FontAwesomeIcon icon={faSortAmountUp} className = { classes[1]} onClick={() => headerSort(1, 2)} />}
                                </div>
                              
                            </div>
                        </ListGroup.Item>
                        {yards.map(y => {
                            return (
                                <ListGroup.Item as={Link} key={`${y.yardId}-yard`} to={`${props.match.url}/${y.yardId}`} className="click-list">
                                    <div className="row">
                                        <div className="col">
                                            {y.yardName}
                                        </div>
                                        <div className="col">
                                            {y.officeName}
                                        </div>
                                    </div>
                                </ListGroup.Item>
                            )
                        })}
                    </ListGroup>
                </div>
            </div>
            <div className="divider my-3" />
            <form action="#" onSubmit={(e) => { e.preventDefault(); saveYard() }}>
                <div className="row">
                    <div className="col">
                        <input
                            className='enc-input-100'
                            value={yard.name}
                            onChange={e => changeYard('name', e.target.value)}
                            placeholder="Yard Name"
                            required />
                    </div>
                    <div className="col">
                        <DropdownList
                            data={offices}
                            textField='name'
                            value={yard.officeLocationId}
                            valueField='officeLocationId'
                            onChange={(e) => changeYard('officeLocationId', e.officeLocationId)}
                        />
                    </div>
                    <div className="col">
                        <Button className='enc-button' type='submit'>Add New Yard</Button>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        {errorText}
                    </div>
                </div>
            </form>
        </div>
    )
}
